import { useState, useMemo } from 'react'
import { Link } from 'react-router'
import logo from './images/logo.svg'

type Props = {
  basePath?: string
}

export const NavigationBar: React.FC<Props> = ({ basePath = '/subscription/branch' }) => {
  const [menuOpen, setMenuOpen] = useState(false)

  const csrfToken = useMemo(() => {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute('content') : ''
  } , [])

  const handleBackdropClick: React.MouseEventHandler<HTMLDivElement> = () => {
    setMenuOpen(false)
  }

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-[0px_8px_16px_0px_rgba(197,197,197,0.05)]">
      {menuOpen && <div className="fixed inset-0 -z-1" onClick={handleBackdropClick} />}
      <div className="max-w-2xl mx-auto px-5 h-14 flex items-center justify-between">
        <Link to={basePath}>
          <img src={logo} alt="FLOWER" className="h-7" />
        </Link>
        <button className="flex flex-col gap-1.25 w-5.25 h-4.5 justify-center cursor-pointer" aria-label="メニュー" onClick={() => setMenuOpen(!menuOpen)}>
          <span className="block h-0.5 w-full bg-black rounded" />
          <span className="block h-0.5 w-full bg-black rounded" />
          <span className="block h-0.5 w-full bg-black rounded" />
        </button>
      </div>
      <div
        className="grid bg-white text-sm"
        style={{
          gridTemplateRows: menuOpen ? '1fr' : '0fr',
          transition: 'grid-template-rows 0.35s cubic-bezier(0.16, 1, 0.3, 1)',
        }}
      >
        <div className="overflow-hidden">
          <div className="px-5 py-6 space-y-4 border-t border-gray/30 max-w-2xl mx-auto">
            <Link to={basePath} className="block text-main" onClick={() => setMenuOpen(false)}>
              トップページ
            </Link>
            <Link to={`${basePath}#faq`} className="block text-main" onClick={() => setMenuOpen(false)}>
              よくある質問
            </Link>
            <form action={`/logout?next=${basePath}`} method="post" onSubmit={() => setMenuOpen(false)}>
              <input type="hidden" name="authenticity_token" value={csrfToken} />
              <button type="submit" className="block w-full text-left text-main cursor-pointer">
                ログアウト
              </button>
            </form>
          </div>
        </div>
      </div>
    </header>
  )
}
